import { useMutation } from '@tanstack/react-query';
import type { WaitlistSignupRequest, WaitlistSignupResponse } from '@/types/waitlist';

async function signupForWaitlist(request: WaitlistSignupRequest): Promise<WaitlistSignupResponse> {
  const response = await fetch('/.netlify/functions/waitlist-signup', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request)
  });

  const data = await response.json();

  if (!response.ok) {
    const error = new Error(data.error || 'Failed to join waitlist');
    (error as Error & { code?: string }).code = data.error;
    throw error;
  }

  return data;
}

export function useWaitlistSignup() {
  return useMutation({
    mutationFn: signupForWaitlist
  });
}
